export default __webpack_public_path__ + "static/FORMES-04-tour-d9cff985a821b09c6406eb9d4b0bc379.svg";